import { Button, Paper } from "@mui/material";

import AppBar from "components/AppBar";
import AnimatedPlaceholder from "components/AnimatedPlaceholder";
import lottiePlaceholders from "assets/placeholders";

function ErrorBoundaryFallback() {
  return (
    <Paper elevation={4} sx={{ height: "100vh" }}>
      <AppBar backAction={false} noRadius showLogo title='GroupUp' />
      <AnimatedPlaceholder
        action={
          <Button onClick={() => window.location.reload()} variant='contained'>
            Refresh App
          </Button>
        }
        animationData={lottiePlaceholders.error}
        text='Ooops! Something went wrong. We will fix it as soon as possible. Thank you for your understanding!'
      />
    </Paper>
  );
}

export default ErrorBoundaryFallback;
